import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import { Phases_getInstance153dg9ipormlv as Phases_getInstance } from '../../request/HttpRequestPipeline.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ByteReadChannel2wzou76jce72d as ByteReadChannel } from '../../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { NullBody1903zz7riiwr0 as NullBody } from '../../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
  Phases_getInstance3j81i0dosd478 as Phases_getInstance_0,
} from '../../statement/HttpResponsePipeline.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var TransformRequestBodyContextClass;
function TransformRequestBodyContext() {
  if (TransformRequestBodyContextClass === VOID) {
    class $ {}
    initMetadataForClass($, 'TransformRequestBodyContext');
    TransformRequestBodyContextClass = $;
  }
  return TransformRequestBodyContextClass;
}
var TransformResponseBodyContextClass;
function TransformResponseBodyContext() {
  if (TransformResponseBodyContextClass === VOID) {
    class $ {}
    initMetadataForClass($, 'TransformResponseBodyContext');
    TransformResponseBodyContextClass = $;
  }
  return TransformResponseBodyContextClass;
}
var OnRequestContextClass;
function OnRequestContext() {
  if (OnRequestContextClass === VOID) {
    class $ {}
    initMetadataForClass($, 'OnRequestContext');
    OnRequestContextClass = $;
  }
  return OnRequestContextClass;
}
function *_generator_invoke__zhh2q8($this, $this$intercept, it, $completion) {
  var tmp = $this.h5v_1(new (OnRequestContext())(), $this$intercept.o4r_1, $this$intercept.p4q(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var RequestHook$install$slambdaClass;
function RequestHook$install$slambda() {
  if (RequestHook$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.h5v_1 = $handler;
      }
      z5g($this$intercept, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$intercept, it), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.z5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    RequestHook$install$slambdaClass = $;
  }
  return RequestHook$install$slambdaClass;
}
function RequestHook$install$slambda_0($handler) {
  var i = new (RequestHook$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.z5g($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var RequestHookClass;
function RequestHook() {
  if (RequestHookClass === VOID) {
    class $ {
      i5v(client, handler) {
        var tmp = Phases_getInstance().o5m_1;
        client.c5g_1.s4r(tmp, RequestHook$install$slambda_0(handler));
      }
      s5m(client, handler) {
        return this.i5v(client, (!(handler == null) ? isSuspendFunction(handler, 3) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RequestHook');
    RequestHookClass = $;
  }
  return RequestHookClass;
}
var RequestHook_instance;
function RequestHook_getInstance() {
  return RequestHook_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$intercept, it, $completion) {
  var tmp = $this.j5v_1(new (TransformRequestBodyContext())(), $this$intercept.o4r_1, $this$intercept.p4q(), $this$intercept.o4r_1.k5v(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var newContent = tmp;
  if (!(newContent == null)) {
    var tmp_0 = $this$intercept.q4q(newContent, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var TransformRequestBodyHook$install$slambdaClass;
function TransformRequestBodyHook$install$slambda() {
  if (TransformRequestBodyHook$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.j5v_1 = $handler;
      }
      z5g($this$intercept, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$intercept, it), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.z5g(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    TransformRequestBodyHook$install$slambdaClass = $;
  }
  return TransformRequestBodyHook$install$slambdaClass;
}
function TransformRequestBodyHook$install$slambda_0($handler) {
  var i = new (TransformRequestBodyHook$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.z5g($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var TransformRequestBodyHookClass;
function TransformRequestBodyHook() {
  if (TransformRequestBodyHookClass === VOID) {
    class $ {
      l5v(client, handler) {
        var tmp = Phases_getInstance().p5m_1;
        client.c5g_1.s4r(tmp, TransformRequestBodyHook$install$slambda_0(handler));
      }
      s5m(client, handler) {
        return this.l5v(client, (!(handler == null) ? isSuspendFunction(handler, 4) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TransformRequestBodyHook');
    TransformRequestBodyHookClass = $;
  }
  return TransformRequestBodyHookClass;
}
var TransformRequestBodyHook_instance;
function TransformRequestBodyHook_getInstance() {
  return TransformRequestBodyHook_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$intercept, it, $completion) {
  var _destruct__k2r9zo = $this$intercept.p4q();
  var typeInfo = _destruct__k2r9zo.df();
  var content = _destruct__k2r9zo.ef();
  if (!isInterface(content, ByteReadChannel()))
    return Unit_instance;
  var tmp = $this.m5v_1(new (TransformResponseBodyContext())(), $this$intercept.o4r_1.q5g(), content, typeInfo, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var newContent = tmp_0;
  var tmp_1;
  if (!(newContent instanceof NullBody())) {
    tmp_1 = !typeInfo.g4s_1.gf(newContent);
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    throw IllegalStateException().o('transformResponseBody returned ' + toString(newContent) + ' but expected value of type ' + typeInfo.toString());
  }
  var tmp_2 = $this$intercept.q4q(new (HttpResponseContainer())(typeInfo, newContent), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var TransformResponseBodyHook$install$slambdaClass;
function TransformResponseBodyHook$install$slambda() {
  if (TransformResponseBodyHook$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.m5v_1 = $handler;
      }
      a5h($this$intercept, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$intercept, it), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.a5h(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    TransformResponseBodyHook$install$slambdaClass = $;
  }
  return TransformResponseBodyHook$install$slambdaClass;
}
function TransformResponseBodyHook$install$slambda_0($handler) {
  var i = new (TransformResponseBodyHook$install$slambda())($handler);
  var l = ($this$intercept, it, $completion) => i.a5h($this$intercept, it, $completion);
  l.$arity = 2;
  return l;
}
var TransformResponseBodyHookClass;
function TransformResponseBodyHook() {
  if (TransformResponseBodyHookClass === VOID) {
    class $ {
      n5v(client, handler) {
        var tmp = Phases_getInstance_0().w5h_1;
        client.d5g_1.s4r(tmp, TransformResponseBodyHook$install$slambda_0(handler));
      }
      s5m(client, handler) {
        return this.n5v(client, (!(handler == null) ? isSuspendFunction(handler, 4) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TransformResponseBodyHook');
    TransformResponseBodyHookClass = $;
  }
  return TransformResponseBodyHookClass;
}
var TransformResponseBodyHook_instance;
function TransformResponseBodyHook_getInstance() {
  return TransformResponseBodyHook_instance;
}
//region block: init
RequestHook_instance = new (RequestHook())();
TransformRequestBodyHook_instance = new (TransformRequestBodyHook())();
TransformResponseBodyHook_instance = new (TransformResponseBodyHook())();
//endregion
//region block: exports
export {
  RequestHook_instance as RequestHook_instance2bttwktu7kqh4,
  TransformRequestBodyHook_instance as TransformRequestBodyHook_instance28bvckwiy2plb,
  TransformResponseBodyHook_instance as TransformResponseBodyHook_instance1622bcqff9eap,
  OnRequestContext as OnRequestContext1tmu5b6bhlblg,
  TransformRequestBodyContext as TransformRequestBodyContext3ll40opqaho0d,
  TransformResponseBodyContext as TransformResponseBodyContext1axf7xx6ifwbj,
};
//endregion

//# sourceMappingURL=KtorCallContexts.mjs.map
